/* sucrase/dist/esm/parser/traverser/expression.js */ function _(require, module, exports, __esModule, __esExport) {
    __esModule();
    exports.parseExpression = parseExpression;
    exports.parseMaybeAssign = parseMaybeAssign;
    exports.baseParseMaybeAssign = baseParseMaybeAssign;
    exports.baseParseConditional = baseParseConditional;
    exports.parseMaybeUnary = parseMaybeUnary;
    exports.parseExprSubscripts = parseExprSubscripts;
    exports.baseParseSubscripts = baseParseSubscripts;
    exports.baseParseSubscript = baseParseSubscript;
    exports.atPossibleAsync = atPossibleAsync;
    exports.parseCallExpressionArguments = parseCallExpressionArguments;
    exports.parseExprAtom = parseExprAtom;
    exports.parseLiteral = parseLiteral;
    exports.parseParenExpression = parseParenExpression;
    exports.parseArrow = parseArrow;
    exports.parseTemplate = parseTemplate;
    exports.parseObj = parseObj;
    exports.parsePropertyName = parsePropertyName;
    exports.parseMethod = parseMethod;
    exports.parseArrowExpression = parseArrowExpression;
    exports.parseFunctionBodyAndFinish = parseFunctionBodyAndFinish;
    exports.parseFunctionBody = parseFunctionBody;
    exports.parseIdentifier = parseIdentifier;
    // A recursive descent parser operates by defining functions for all
    // syntactic elements, and recursively calling those, each function
    // advancing the input stream and returning an AST node. Precedence
    // of constructs (for example, the fact that `!x[1]` means `!(x[1])`
    // instead of `(!x)[1]` is handled by the fact that the parser
    // function that parses unary prefix operators is called first, and
    // in turn calls the function that parses `[]` subscripts — that
    // way, it'll receive the node for `x[1]` already parsed, and wraps
    // *that* in the unary operator node.
    //
    // Acorn uses an [operator precedence parser][opp] to handle binary
    // operator precedence, because it is much more compact than using
    // the technique outlined above, which uses different, nesting
    // functions to specify precedence, for all of the ten binary
    // precedence levels that JavaScript defines.
    //
    // [opp]: http://en.wikipedia.org/wiki/Operator-precedence_parser
    const flow_1 = require("9b8d43cd0a") /* ../plugins/flow */;
    const index_1 = require("d7708a7d24") /* ../plugins/jsx/index */;
    const types_1 = require("85c51351f6") /* ../plugins/types */;
    const typescript_1 = require("6a970c22b9") /* ../plugins/typescript */;
    const index_2 = require("bfb18d0576") /* ../tokenizer/index */;
    const keywords_1 = require("99ff836c64") /* ../tokenizer/keywords */;
    const state_1 = require("eda46439d5") /* ../tokenizer/state */;
    const types_2 = require("f0c35cbd76") /* ../tokenizer/types */;
    const charcodes_1 = require("22746c8ce8") /* ../util/charcodes */;
    const identifier_1 = require("364148c9f0") /* ../util/identifier */;
    const base_1 = require("540718e523") /* ./base */;
    const lval_1 = require("4cefc59e67") /* ./lval */;
    const statement_1 = require("e3b9989da1") /* ./statement */;
    const util_1 = require("bc94bbadc1") /* ./util */;
    class StopState {
        constructor(stop) {
            this.stop = stop;
        }
    }
    exports.StopState = StopState;
    // ### Expression parsing
    // These nest, from the most general expression type at the top to
    // 'atomic', nondivisible expression types at the bottom. Most of
    // the functions will simply let the function (s) below them parse,
    // and, *if* the syntactic construct they handle is present, wrap
    // the AST node that the inner parser gave them in another node.
    function parseExpression(noIn = false) {
        parseMaybeAssign(noIn);
        if ((0, index_2.match)(types_2.TokenType.comma)) {
            while ((0, index_2.eat)(types_2.TokenType.comma)) {
                parseMaybeAssign(noIn);
            }
        }
    }
    /**
     * noIn is used when parsing a for loop so that we don't interpret a following "in" as the binary
     * operatior.
     * isWithinParens is used to indicate that we're parsing something that might be a comma expression
     * or might be an arrow function or might be a Flow type assertion (which requires explicit parens).
     * In these cases, we should allow : and ?: after the initial "left" part.
     */
    function parseMaybeAssign(noIn = false, isWithinParens = false) {
        if (base_1.isTypeScriptEnabled) {
            return (0, typescript_1.tsParseMaybeAssign)(noIn, isWithinParens);
        }
        else if (base_1.isFlowEnabled) {
            return (0, flow_1.flowParseMaybeAssign)(noIn, isWithinParens);
        }
        else {
            return baseParseMaybeAssign(noIn, isWithinParens);
        }
    }
    // Parse an assignment expression. This includes applications of
    // operators like `+=`.
    // Returns true if the expression was an arrow function.
    function baseParseMaybeAssign(noIn, isWithinParens) {
        if ((0, index_2.match)(types_2.TokenType._yield)) {
            parseYield();
            return false;
        }
        if ((0, index_2.match)(types_2.TokenType.parenL) || (0, index_2.match)(types_2.TokenType.name) || (0, index_2.match)(types_2.TokenType._yield)) {
            base_1.state.potentialArrowAt = base_1.state.start;
        }
        const wasArrow = parseMaybeConditional(noIn);
        if (isWithinParens) {
            parseParenItem();
        }
        if (base_1.state.type & types_2.TokenType.IS_ASSIGN) {
            (0, index_2.next)();
            parseMaybeAssign(noIn);
            return false;
        }
        return wasArrow;
    }
    // Parse a ternary conditional (`?:`) operator.
    // Returns true if the expression was an arrow function.
    function parseMaybeConditional(noIn) {
        const wasArrow = parseExprOps(noIn);
        if (wasArrow) {
            return true;
        }
        parseConditional(noIn);
        return false;
    }
    function parseConditional(noIn) {
        if (base_1.isTypeScriptEnabled || base_1.isFlowEnabled) {
            (0, types_1.typedParseConditional)(noIn);
        }
        else {
            baseParseConditional(noIn);
        }
    }
    function baseParseConditional(noIn) {
        if ((0, index_2.eat)(types_2.TokenType.question)) {
            parseMaybeAssign();
            (0, util_1.expect)(types_2.TokenType.colon);
            parseMaybeAssign(noIn);
        }
    }
    // Start the precedence parser.
    // Returns true if this was an arrow function
    function parseExprOps(noIn) {
        const startTokenIndex = base_1.state.tokens.length;
        const wasArrow = parseMaybeUnary();
        if (wasArrow) {
            return true;
        }
        parseExprOp(startTokenIndex, -1, noIn);
        return false;
    }
    // Parse binary operators with the operator precedence parsing
    // algorithm. `left` is the left-hand side of the operator.
    // `minPrec` provides context that allows the function to stop and
    // defer further parser to one of its callers when it encounters an
    // operator that has a lower precedence than the set it is parsing.
    function parseExprOp(startTokenIndex, minPrec, noIn) {
        if (base_1.isTypeScriptEnabled &&
            (types_2.TokenType._in & types_2.TokenType.PRECEDENCE_MASK) > minPrec &&
            !(0, util_1.hasPrecedingLineBreak)() &&
            ((0, util_1.eatContextual)(keywords_1.ContextualKeyword._as) || (0, util_1.eatContextual)(keywords_1.ContextualKeyword._satisfies))) {
            const oldIsType = (0, index_2.pushTypeContext)(1);
            (0, typescript_1.tsParseType)();
            (0, index_2.popTypeContext)(oldIsType);
            (0, index_2.rescan_gt)();
            parseExprOp(startTokenIndex, minPrec, noIn);
            return;
        }
        const prec = base_1.state.type & types_2.TokenType.PRECEDENCE_MASK;
        if (prec > 0 && (!noIn || !(0, index_2.match)(types_2.TokenType._in))) {
            if (prec > minPrec) {
                const op = base_1.state.type;
                (0, index_2.next)();
                if (op === types_2.TokenType.nullishCoalescing) {
                    base_1.state.tokens[base_1.state.tokens.length - 1].nullishStartIndex = startTokenIndex;
                }
                const rhsStartTokenIndex = base_1.state.tokens.length;
                parseMaybeUnary();
                // Extend the right operand of this operator if possible.
                parseExprOp(rhsStartTokenIndex, op & types_2.TokenType.IS_RIGHT_ASSOCIATIVE ? prec - 1 : prec, noIn);
                if (op === types_2.TokenType.nullishCoalescing) {
                    base_1.state.tokens[startTokenIndex].numNullishCoalesceStarts++;
                    base_1.state.tokens[base_1.state.tokens.length - 1].numNullishCoalesceEnds++;
                }
                // Continue with any future operator holding this expression as the left operand.
                parseExprOp(startTokenIndex, minPrec, noIn);
            }
        }
    }
    // Parse unary operators, both prefix and postfix.
    // Returns true if this was an arrow function.
    function parseMaybeUnary() {
        if (base_1.isTypeScriptEnabled && !base_1.isJSXEnabled && (0, index_2.eat)(types_2.TokenType.lessThan)) {
            (0, typescript_1.tsParseTypeAssertion)();
            return false;
        }
        if ((0, util_1.isContextual)(keywords_1.ContextualKeyword._module) &&
            (0, index_2.lookaheadCharCode)() === charcodes_1.charCodes.leftCurlyBrace &&
            !(0, util_1.hasFollowingLineBreak)()) {
            parseModuleExpression();
            return false;
        }
        if (base_1.state.type & types_2.TokenType.IS_PREFIX) {
            (0, index_2.next)();
            parseMaybeUnary();
            return false;
        }
        const wasArrow = parseExprSubscripts();
        if (wasArrow) {
            return true;
        }
        while (base_1.state.type & types_2.TokenType.IS_POSTFIX && !(0, util_1.canInsertSemicolon)()) {
            // The tokenizer calls everything a preincrement, so make it a postincrement when
            // we see it in that context.
            if (base_1.state.type === types_2.TokenType.preIncDec) {
                base_1.state.type = types_2.TokenType.postIncDec;
            }
            (0, index_2.next)();
        }
        return false;
    }
    // Parse call, dot, and `[]`-subscript expressions.
    // Returns true if this was an arrow function.
    function parseExprSubscripts() {
        const startTokenIndex = base_1.state.tokens.length;
        const wasArrow = parseExprAtom();
        if (wasArrow) {
            return true;
        }
        parseSubscripts(startTokenIndex);
        // If there was any optional chain operation, the start token would be marked
        // as such, so also mark the end now.
        if (base_1.state.tokens.length > startTokenIndex && base_1.state.tokens[startTokenIndex].isOptionalChainStart) {
            base_1.state.tokens[base_1.state.tokens.length - 1].isOptionalChainEnd = true;
        }
        return false;
    }
    function parseSubscripts(startTokenIndex, noCalls = false) {
        if (base_1.isFlowEnabled) {
            (0, flow_1.flowParseSubscripts)(startTokenIndex, noCalls);
        }
        else {
            baseParseSubscripts(startTokenIndex, noCalls);
        }
    }
    function baseParseSubscripts(startTokenIndex, noCalls = false) {
        const stopState = new StopState(false);
        do {
            parseSubscript(startTokenIndex, noCalls, stopState);
        } while (!stopState.stop && !base_1.state.error);
    }
    function parseSubscript(startTokenIndex, noCalls, stopState) {
        if (base_1.isTypeScriptEnabled) {
            (0, typescript_1.tsParseSubscript)(startTokenIndex, noCalls, stopState);
        }
        else if (base_1.isFlowEnabled) {
            (0, flow_1.flowParseSubscript)(startTokenIndex, noCalls, stopState);
        }
        else {
            baseParseSubscript(startTokenIndex, noCalls, stopState);
        }
    }
    /** Set 'state.stop = true' to indicate that we should stop parsing subscripts. */
    function baseParseSubscript(startTokenIndex, noCalls, stopState) {
        if (!noCalls && (0, index_2.eat)(types_2.TokenType.doubleColon)) {
            parseNoCallExpr();
            stopState.stop = true;
            // Propagate startTokenIndex so that `a::b?.()` will keep `a` as the first token. We may want
            // to revisit this in the future when fully supporting bind syntax.
            parseSubscripts(startTokenIndex, noCalls);
        }
        else if ((0, index_2.match)(types_2.TokenType.questionDot)) {
            base_1.state.tokens[startTokenIndex].isOptionalChainStart = true;
            if (noCalls && (0, index_2.lookaheadType)() === types_2.TokenType.parenL) {
                stopState.stop = true;
                return;
            }
            (0, index_2.next)();
            base_1.state.tokens[base_1.state.tokens.length - 1].subscriptStartIndex = startTokenIndex;
            if ((0, index_2.eat)(types_2.TokenType.bracketL)) {
                parseExpression();
                (0, util_1.expect)(types_2.TokenType.bracketR);
            }
            else if ((0, index_2.eat)(types_2.TokenType.parenL)) {
                parseCallExpressionArguments();
            }
            else {
                parseMaybePrivateName();
            }
        }
        else if ((0, index_2.eat)(types_2.TokenType.dot)) {
            base_1.state.tokens[base_1.state.tokens.length - 1].subscriptStartIndex = startTokenIndex;
            parseMaybePrivateName();
        }
        else if ((0, index_2.eat)(types_2.TokenType.bracketL)) {
            base_1.state.tokens[base_1.state.tokens.length - 1].subscriptStartIndex = startTokenIndex;
            parseExpression();
            (0, util_1.expect)(types_2.TokenType.bracketR);
        }
        else if (!noCalls && (0, index_2.match)(types_2.TokenType.parenL)) {
            if (atPossibleAsync()) {
                // We see "async", but it's possible it's a usage of the name "async". Parse as if it's a
                // function call, and if we see an arrow later, backtrack and re-parse as a parameter list.
                const snapshot = base_1.state.snapshot();
                const asyncStartTokenIndex = base_1.state.tokens.length;
                (0, index_2.next)();
                base_1.state.tokens[base_1.state.tokens.length - 1].subscriptStartIndex = startTokenIndex;
                const callContextId = (0, base_1.getNextContextId)();
                base_1.state.tokens[base_1.state.tokens.length - 1].contextId = callContextId;
                parseCallExpressionArguments();
                base_1.state.tokens[base_1.state.tokens.length - 1].contextId = callContextId;
                if (shouldParseAsyncArrow()) {
                    // We hit an arrow, so backtrack and start again parsing function parameters.
                    base_1.state.restoreFromSnapshot(snapshot);
                    stopState.stop = true;
                    base_1.state.scopeDepth++;
                    (0, statement_1.parseFunctionParams)();
                    parseAsyncArrowFromCallExpression(asyncStartTokenIndex);
                }
            }
            else {
                (0, index_2.next)();
                base_1.state.tokens[base_1.state.tokens.length - 1].subscriptStartIndex = startTokenIndex;
                const callContextId = (0, base_1.getNextContextId)();
                base_1.state.tokens[base_1.state.tokens.length - 1].contextId = callContextId;
                parseCallExpressionArguments();
                base_1.state.tokens[base_1.state.tokens.length - 1].contextId = callContextId;
            }
        }
        else if ((0, index_2.match)(types_2.TokenType.backQuote)) {
            // Tagged template expression.
            parseTemplate();
        }
        else {
            stopState.stop = true;
        }
    }
    function atPossibleAsync() {
        // This was made less strict than the original version to avoid passing around nodes, but it
        // should be safe to have rare false positives here.
        return (base_1.state.tokens[base_1.state.tokens.length - 1].contextualKeyword === keywords_1.ContextualKeyword._async &&
            !(0, util_1.canInsertSemicolon)());
    }
    function parseCallExpressionArguments() {
        let first = true;
        while (!(0, index_2.eat)(types_2.TokenType.parenR) && !base_1.state.error) {
            if (first) {
                first = false;
            }
            else {
                (0, util_1.expect)(types_2.TokenType.comma);
                if ((0, index_2.eat)(types_2.TokenType.parenR)) {
                    break;
                }
            }
            parseExprListItem(false);
        }
    }
    function shouldParseAsyncArrow() {
        return (0, index_2.match)(types_2.TokenType.colon) || (0, index_2.match)(types_2.TokenType.arrow);
    }
    function parseAsyncArrowFromCallExpression(startTokenIndex) {
        if (base_1.isTypeScriptEnabled) {
            (0, typescript_1.tsStartParseAsyncArrowFromCallExpression)();
        }
        else if (base_1.isFlowEnabled) {
            (0, flow_1.flowStartParseAsyncArrowFromCallExpression)();
        }
        (0, util_1.expect)(types_2.TokenType.arrow);
        parseArrowExpression(startTokenIndex);
    }
    // Parse a no-call expression (like argument of `new` or `::` operators).
    function parseNoCallExpr() {
        const startTokenIndex = base_1.state.tokens.length;
        parseExprAtom();
        parseSubscripts(startTokenIndex, true);
    }
    // Parse an atomic expression — either a single token that is an
    // expression, an expression started by a keyword like `function` or
    // `new`, or an expression wrapped in punctuation like `()`, `[]`,
    // or `{}`.
    // Returns true if the parsed expression was an arrow function.
    function parseExprAtom() {
        if ((0, index_2.eat)(types_2.TokenType.modulo)) {
            // V8 intrinsic expression. Just parse the identifier, and the function invocation is parsed
            // naturally.
            parseIdentifier();
            return false;
        }
        if ((0, index_2.match)(types_2.TokenType.jsxText) || (0, index_2.match)(types_2.TokenType.jsxEmptyText)) {
            parseLiteral();
            return false;
        }
        else if ((0, index_2.match)(types_2.TokenType.lessThan) && base_1.isJSXEnabled) {
            base_1.state.type = types_2.TokenType.jsxTagStart;
            (0, index_1.jsxParseElement)();
            (0, index_2.next)();
            return false;
        }
        const canBeArrow = base_1.state.potentialArrowAt === base_1.state.start;
        switch (base_1.state.type) {
            case types_2.TokenType.slash:
            case types_2.TokenType.assign:
                (0, index_2.retokenizeSlashAsRegex)();
            // Fall through.
            case types_2.TokenType._super:
            case types_2.TokenType._this:
            case types_2.TokenType.regexp:
            case types_2.TokenType.num:
            case types_2.TokenType.bigint:
            case types_2.TokenType.decimal:
            case types_2.TokenType.string:
            case types_2.TokenType._null:
            case types_2.TokenType._true:
            case types_2.TokenType._false:
                (0, index_2.next)();
                return false;
            case types_2.TokenType._import:
                (0, index_2.next)();
                if ((0, index_2.match)(types_2.TokenType.dot)) {
                    // import.meta
                    base_1.state.tokens[base_1.state.tokens.length - 1].type = types_2.TokenType.name;
                    (0, index_2.next)();
                    parseIdentifier();
                }
                return false;
            case types_2.TokenType.name: {
                const startTokenIndex = base_1.state.tokens.length;
                const functionStart = base_1.state.start;
                const contextualKeyword = base_1.state.contextualKeyword;
                parseIdentifier();
                if (contextualKeyword === keywords_1.ContextualKeyword._await) {
                    parseAwait();
                    return false;
                }
                else if (contextualKeyword === keywords_1.ContextualKeyword._async &&
                    (0, index_2.match)(types_2.TokenType._function) &&
                    !(0, util_1.canInsertSemicolon)()) {
                    (0, index_2.next)();
                    (0, statement_1.parseFunction)(functionStart, false);
                    return false;
                }
                else if (canBeArrow &&
                    contextualKeyword === keywords_1.ContextualKeyword._async &&
                    !(0, util_1.canInsertSemicolon)() &&
                    (0, index_2.match)(types_2.TokenType.name)) {
                    base_1.state.scopeDepth++;
                    (0, lval_1.parseBindingIdentifier)(false);
                    (0, util_1.expect)(types_2.TokenType.arrow);
                    // let foo = async bar => {};
                    parseArrowExpression(startTokenIndex);
                    return true;
                }
                else if ((0, index_2.match)(types_2.TokenType._do) && !(0, util_1.canInsertSemicolon)()) {
                    (0, index_2.next)();
                    (0, statement_1.parseBlock)();
                    return false;
                }
                if (canBeArrow && !(0, util_1.canInsertSemicolon)() && (0, index_2.match)(types_2.TokenType.arrow)) {
                    base_1.state.scopeDepth++;
                    (0, lval_1.markPriorBindingIdentifier)(false);
                    (0, util_1.expect)(types_2.TokenType.arrow);
                    parseArrowExpression(startTokenIndex);
                    return true;
                }
                base_1.state.tokens[base_1.state.tokens.length - 1].identifierRole = index_2.IdentifierRole.Access;
                return false;
            }
            case types_2.TokenType._do: {
                (0, index_2.next)();
                (0, statement_1.parseBlock)();
                return false;
            }
            case types_2.TokenType.parenL: {
                const wasArrow = parseParenAndDistinguishExpression(canBeArrow);
                return wasArrow;
            }
            case types_2.TokenType.bracketL:
                (0, index_2.next)();
                parseExprList(types_2.TokenType.bracketR, true);
                return false;
            case types_2.TokenType.braceL:
                parseObj(false, false);
                return false;
            case types_2.TokenType._function:
                parseFunctionExpression();
                return false;
            case types_2.TokenType.at:
                (0, statement_1.parseDecorators)();
            // Fall through.
            case types_2.TokenType._class:
                (0, statement_1.parseClass)(false);
                return false;
            case types_2.TokenType._new:
                parseNew();
                return false;
            case types_2.TokenType.backQuote:
                parseTemplate();
                return false;
            case types_2.TokenType.doubleColon: {
                (0, index_2.next)();
                parseNoCallExpr();
                return false;
            }
            case types_2.TokenType.hash: {
                const code = (0, index_2.lookaheadCharCode)();
                if (identifier_1.IS_IDENTIFIER_START[code] || code === charcodes_1.charCodes.backslash) {
                    parseMaybePrivateName();
                }
                else {
                    (0, index_2.next)();
                }
                // Smart pipeline topic reference.
                return false;
            }
            default:
                (0, util_1.unexpected)();
                return false;
        }
    }
    function parseMaybePrivateName() {
        (0, index_2.eat)(types_2.TokenType.hash);
        parseIdentifier();
    }
    function parseFunctionExpression() {
        const functionStart = base_1.state.start;
        parseIdentifier();
        if ((0, index_2.eat)(types_2.TokenType.dot)) {
            // function.sent
            parseIdentifier();
        }
        (0, statement_1.parseFunction)(functionStart, false);
    }
    function parseLiteral() {
        (0, index_2.next)();
    }
    function parseParenExpression() {
        (0, util_1.expect)(types_2.TokenType.parenL);
        parseExpression();
        (0, util_1.expect)(types_2.TokenType.parenR);
    }
    // Returns true if this was an arrow expression.
    function parseParenAndDistinguishExpression(canBeArrow) {
        // Assume this is a normal parenthesized expression, but if we see an arrow, we'll bail and
        // start over as a parameter list.
        const snapshot = base_1.state.snapshot();
        const startTokenIndex = base_1.state.tokens.length;
        (0, util_1.expect)(types_2.TokenType.parenL);
        let first = true;
        while (!(0, index_2.match)(types_2.TokenType.parenR) && !base_1.state.error) {
            if (first) {
                first = false;
            }
            else {
                (0, util_1.expect)(types_2.TokenType.comma);
                if ((0, index_2.match)(types_2.TokenType.parenR)) {
                    break;
                }
            }
            if ((0, index_2.match)(types_2.TokenType.ellipsis)) {
                (0, lval_1.parseRest)(false /* isBlockScope */);
                parseParenItem();
                break;
            }
            else {
                parseMaybeAssign(false, true);
            }
        }
        (0, util_1.expect)(types_2.TokenType.parenR);
        if (canBeArrow && shouldParseArrow()) {
            const wasArrow = parseArrow();
            if (wasArrow) {
                // It was an arrow function this whole time, so start over and parse it as params so that we
                // get proper token annotations.
                base_1.state.restoreFromSnapshot(snapshot);
                base_1.state.scopeDepth++;
                // Don't specify a context ID because arrow functions don't need a context ID.
                (0, statement_1.parseFunctionParams)();
                parseArrow();
                parseArrowExpression(startTokenIndex);
                if (base_1.state.error) {
                    // Nevermind! This must have been something that looks very much like an
                    // arrow function but where its "parameter list" isn't actually a valid
                    // parameter list. Force non-arrow parsing.
                    // See https://github.com/alangpierce/sucrase/issues/666 for an example.
                    base_1.state.restoreFromSnapshot(snapshot);
                    parseParenAndDistinguishExpression(false);
                    return false;
                }
                return true;
            }
        }
        return false;
    }
    function shouldParseArrow() {
        return (0, index_2.match)(types_2.TokenType.colon) || !(0, util_1.canInsertSemicolon)();
    }
    // Returns whether there was an arrow token.
    function parseArrow() {
        if (base_1.isTypeScriptEnabled) {
            return (0, typescript_1.tsParseArrow)();
        }
        else if (base_1.isFlowEnabled) {
            return (0, flow_1.flowParseArrow)();
        }
        else {
            return (0, index_2.eat)(types_2.TokenType.arrow);
        }
    }
    function parseParenItem() {
        if (base_1.isTypeScriptEnabled || base_1.isFlowEnabled) {
            (0, types_1.typedParseParenItem)();
        }
    }
    // New's precedence is slightly tricky. It must allow its argument to
    // be a `[]` or dot subscript expression, but not a call — at least,
    // not without wrapping it in parentheses. Thus, it uses the noCalls
    // argument to parseSubscripts to prevent it from consuming the
    // argument list.
    function parseNew() {
        (0, util_1.expect)(types_2.TokenType._new);
        if ((0, index_2.eat)(types_2.TokenType.dot)) {
            // new.target
            parseIdentifier();
            return;
        }
        parseNewCallee();
        if (base_1.isFlowEnabled) {
            (0, flow_1.flowStartParseNewArguments)();
        }
        if ((0, index_2.eat)(types_2.TokenType.parenL)) {
            parseExprList(types_2.TokenType.parenR);
        }
    }
    function parseNewCallee() {
        parseNoCallExpr();
        (0, index_2.eat)(types_2.TokenType.questionDot);
    }
    function parseTemplate() {
        // Finish `, read quasi
        (0, index_2.nextTemplateToken)();
        // Finish quasi, read ${
        (0, index_2.nextTemplateToken)();
        while (!(0, index_2.match)(types_2.TokenType.backQuote) && !base_1.state.error) {
            (0, util_1.expect)(types_2.TokenType.dollarBraceL);
            parseExpression();
            // Finish }, read quasi
            (0, index_2.nextTemplateToken)();
            // Finish quasi, read either ${ or `
            (0, index_2.nextTemplateToken)();
        }
        (0, index_2.next)();
    }
    // Parse an object literal or binding pattern.
    function parseObj(isPattern, isBlockScope) {
        // Attach a context ID to the object open and close brace and each object key.
        const contextId = (0, base_1.getNextContextId)();
        let first = true;
        (0, index_2.next)();
        base_1.state.tokens[base_1.state.tokens.length - 1].contextId = contextId;
        while (!(0, index_2.eat)(types_2.TokenType.braceR) && !base_1.state.error) {
            if (first) {
                first = false;
            }
            else {
                (0, util_1.expect)(types_2.TokenType.comma);
                if ((0, index_2.eat)(types_2.TokenType.braceR)) {
                    break;
                }
            }
            let isGenerator = false;
            if ((0, index_2.match)(types_2.TokenType.ellipsis)) {
                const previousIndex = base_1.state.tokens.length;
                (0, lval_1.parseSpread)();
                if (isPattern) {
                    // Mark role when the only thing being spread over is an identifier.
                    if (base_1.state.tokens.length === previousIndex + 2) {
                        (0, lval_1.markPriorBindingIdentifier)(isBlockScope);
                    }
                    if ((0, index_2.eat)(types_2.TokenType.braceR)) {
                        break;
                    }
                }
                continue;
            }
            if (!isPattern) {
                isGenerator = (0, index_2.eat)(types_2.TokenType.star);
            }
            if (!isPattern && (0, util_1.isContextual)(keywords_1.ContextualKeyword._async)) {
                if (isGenerator)
                    (0, util_1.unexpected)();
                parseIdentifier();
                if ((0, index_2.match)(types_2.TokenType.colon) ||
                    (0, index_2.match)(types_2.TokenType.parenL) ||
                    (0, index_2.match)(types_2.TokenType.braceR) ||
                    (0, index_2.match)(types_2.TokenType.eq) ||
                    (0, index_2.match)(types_2.TokenType.comma)) {
                    // This is a key called "async" rather than an async function.
                }
                else {
                    if ((0, index_2.match)(types_2.TokenType.star)) {
                        (0, index_2.next)();
                        isGenerator = true;
                    }
                    parsePropertyName(contextId);
                }
            }
            else {
                parsePropertyName(contextId);
            }
            parseObjPropValue(isPattern, isBlockScope, contextId);
        }
        base_1.state.tokens[base_1.state.tokens.length - 1].contextId = contextId;
    }
    function isGetterOrSetterMethod(isPattern) {
        // We go off of the next and don't bother checking if the node key is actually "get" or "set".
        // This lets us avoid generating a node, and should only make the validation worse.
        return (!isPattern &&
            ((0, index_2.match)(types_2.TokenType.string) || // get "string"() {}
                (0, index_2.match)(types_2.TokenType.num) || // get 1() {}
                (0, index_2.match)(types_2.TokenType.bracketL) || // get ["string"]() {}
                (0, index_2.match)(types_2.TokenType.name) || // get foo() {}
                !!(base_1.state.type & types_2.TokenType.IS_KEYWORD)) // get debugger() {}
        );
    }
    // Returns true if this was a method.
    function parseObjectMethod(isPattern, objectContextId) {
        // We don't need to worry about modifiers because object methods can't have optional bodies, so
        // the start will never be used.
        const functionStart = base_1.state.start;
        if ((0, index_2.match)(types_2.TokenType.parenL)) {
            if (isPattern)
                (0, util_1.unexpected)();
            parseMethod(functionStart, /* isConstructor */ false);
            return true;
        }
        if (isGetterOrSetterMethod(isPattern)) {
            parsePropertyName(objectContextId);
            parseMethod(functionStart, /* isConstructor */ false);
            return true;
        }
        return false;
    }
    function parseObjectProperty(isPattern, isBlockScope) {
        if ((0, index_2.eat)(types_2.TokenType.colon)) {
            if (isPattern) {
                (0, lval_1.parseMaybeDefault)(isBlockScope);
            }
            else {
                parseMaybeAssign(false);
            }
            return;
        }
        // Since there's no colon, we assume this is an object shorthand.
        // If we're in a destructuring, we've now discovered that the key was actually an assignee, so
        // we need to tag it as a declaration with the appropriate scope. Otherwise, we might need to
        // transform it on access, so mark it as a normal object shorthand.
        let identifierRole;
        if (isPattern) {
            if (base_1.state.scopeDepth === 0) {
                identifierRole = index_2.IdentifierRole.ObjectShorthandTopLevelDeclaration;
            }
            else if (isBlockScope) {
                identifierRole = index_2.IdentifierRole.ObjectShorthandBlockScopedDeclaration;
            }
            else {
                identifierRole = index_2.IdentifierRole.ObjectShorthandFunctionScopedDeclaration;
            }
        }
        else {
            identifierRole = index_2.IdentifierRole.ObjectShorthand;
        }
        base_1.state.tokens[base_1.state.tokens.length - 1].identifierRole = identifierRole;
        // Regardless of whether we know this to be a pattern or if we're in an ambiguous context, allow
        // parsing as if there's a default value.
        (0, lval_1.parseMaybeDefault)(isBlockScope, true);
    }
    function parseObjPropValue(isPattern, isBlockScope, objectContextId) {
        if (base_1.isTypeScriptEnabled) {
            (0, typescript_1.tsStartParseObjPropValue)();
        }
        else if (base_1.isFlowEnabled) {
            (0, flow_1.flowStartParseObjPropValue)();
        }
        const wasMethod = parseObjectMethod(isPattern, objectContextId);
        if (!wasMethod) {
            parseObjectProperty(isPattern, isBlockScope);
        }
    }
    function parsePropertyName(objectContextId) {
        if (base_1.isFlowEnabled) {
            (0, flow_1.flowParseVariance)();
        }
        if ((0, index_2.eat)(types_2.TokenType.bracketL)) {
            base_1.state.tokens[base_1.state.tokens.length - 1].contextId = objectContextId;
            parseMaybeAssign();
            (0, util_1.expect)(types_2.TokenType.bracketR);
            base_1.state.tokens[base_1.state.tokens.length - 1].contextId = objectContextId;
        }
        else {
            if ((0, index_2.match)(types_2.TokenType.num) || (0, index_2.match)(types_2.TokenType.string) || (0, index_2.match)(types_2.TokenType.bigint) || (0, index_2.match)(types_2.TokenType.decimal)) {
                parseExprAtom();
            }
            else {
                parseMaybePrivateName();
            }
            base_1.state.tokens[base_1.state.tokens.length - 1].identifierRole = index_2.IdentifierRole.ObjectKey;
            base_1.state.tokens[base_1.state.tokens.length - 1].contextId = objectContextId;
        }
    }
    // Parse object or class method.
    function parseMethod(functionStart, isConstructor) {
        const funcContextId = (0, base_1.getNextContextId)();
        base_1.state.scopeDepth++;
        const startTokenIndex = base_1.state.tokens.length;
        const allowModifiers = isConstructor; // For TypeScript parameter properties
        (0, statement_1.parseFunctionParams)(allowModifiers, funcContextId);
        parseFunctionBodyAndFinish(functionStart, funcContextId);
        const endTokenIndex = base_1.state.tokens.length;
        base_1.state.scopes.push(new state_1.Scope(startTokenIndex, endTokenIndex, true));
        base_1.state.scopeDepth--;
    }
    // Parse arrow function expression.
    // If the parameters are provided, they will be converted to an
    // assignable list.
    function parseArrowExpression(startTokenIndex) {
        parseFunctionBody(true);
        const endTokenIndex = base_1.state.tokens.length;
        base_1.state.scopes.push(new state_1.Scope(startTokenIndex, endTokenIndex, true));
        base_1.state.scopeDepth--;
    }
    function parseFunctionBodyAndFinish(functionStart, funcContextId = 0) {
        if (base_1.isTypeScriptEnabled) {
            (0, typescript_1.tsParseFunctionBodyAndFinish)(functionStart, funcContextId);
        }
        else if (base_1.isFlowEnabled) {
            (0, flow_1.flowParseFunctionBodyAndFinish)(funcContextId);
        }
        else {
            parseFunctionBody(false, funcContextId);
        }
    }
    function parseFunctionBody(allowExpression, funcContextId = 0) {
        const isExpression = allowExpression && !(0, index_2.match)(types_2.TokenType.braceL);
        if (isExpression) {
            parseMaybeAssign();
        }
        else {
            (0, statement_1.parseBlock)(true /* isFunctionScope */, funcContextId);
        }
    }
    // Parses a comma-separated list of expressions, and returns them as
    // an array. `close` is the token type that ends the list, and
    // `allowEmpty` can be turned on to allow subsequent commas with
    // nothing in between them to be parsed as `null` (which is needed
    // for array literals).
    function parseExprList(close, allowEmpty = false) {
        let first = true;
        while (!(0, index_2.eat)(close) && !base_1.state.error) {
            if (first) {
                first = false;
            }
            else {
                (0, util_1.expect)(types_2.TokenType.comma);
                if ((0, index_2.eat)(close))
                    break;
            }
            parseExprListItem(allowEmpty);
        }
    }
    function parseExprListItem(allowEmpty) {
        if (allowEmpty && (0, index_2.match)(types_2.TokenType.comma)) {
            // Empty item; nothing more to parse for this item.
        }
        else if ((0, index_2.match)(types_2.TokenType.ellipsis)) {
            (0, lval_1.parseSpread)();
            parseParenItem();
        }
        else if ((0, index_2.match)(types_2.TokenType.question)) {
            // Partial function application proposal.
            (0, index_2.next)();
        }
        else {
            parseMaybeAssign(false, true);
        }
    }
    // Parse the next token as an identifier.
    function parseIdentifier() {
        (0, index_2.next)();
        base_1.state.tokens[base_1.state.tokens.length - 1].type = types_2.TokenType.name;
    }
    // Parses await expression inside async function.
    function parseAwait() {
        parseMaybeUnary();
    }
    // Parses yield expression inside generator.
    function parseYield() {
        (0, index_2.next)();
        if (!(0, index_2.match)(types_2.TokenType.semi) && !(0, util_1.canInsertSemicolon)()) {
            (0, index_2.eat)(types_2.TokenType.star);
            parseMaybeAssign();
        }
    }
    // https://github.com/tc39/proposal-js-module-blocks
    function parseModuleExpression() {
        (0, util_1.expectContextual)(keywords_1.ContextualKeyword._module);
        (0, util_1.expect)(types_2.TokenType.braceL);
        // For now, just call parseBlockBody to parse the block. In the future when we
        // implement full support, we'll want to emit scopes and possibly other
        // information.
        (0, statement_1.parseBlockBody)(types_2.TokenType.braceR);
    }
}
